// src/components/hints/HintsRegistry.js

export const HINTS_DATA = {
  // 1. Почти на весь экран с картинкой
  'mafia_intro': {
    opacity: 0.5,
    closeOnOverlayClick: true,
    markAsReadOnOverlayClick: true,
    imageKey: 'hints.mafia_intro.image', // Путь к картинке из локализации
    className: 'hint-card-large',
    titleKey: 'hints.mafia_intro.title',
    textKey: 'hints.mafia_intro.text',
    buttonKey: 'hints.mafia_intro.button'
  },

  // 2. Без изображения, только текст
  'voting_rules': {
    opacity: 0.5,
    closeOnOverlayClick: false, // Обязательно нажать на кнопку
    markAsReadOnOverlayClick: false,
    className: 'hint-card-standard',
    titleKey: 'hints.voting_rules.title',
    textKey: 'hints.voting_rules.text',
    buttonKey: 'hints.voting_rules.button'
  },

  // 3. Маленькая подсказка в конкретном месте (например, возле чата)
  'ghost_chat_info': {
    opacity: 0.2,
    closeOnOverlayClick: true,
    markAsReadOnOverlayClick: true,
    className: 'hint-mini-tooltip',
    style: { bottom: '80px', right: '20px' }, // Конкретное место
    textKey: 'hints.ghost_chat_info.text'
    // Кнопки нет -> закроется по клику на оверлей
  }
};